// ค่าสถานะของ master data ที่ API ส่งมา (enum: เปิดใช้งาน | ไม่ใช้งาน)
export const STATUS_ACTIVE = 'เปิดใช้งาน'
export const STATUS_INACTIVE = 'ไม่ใช้งาน'
